module.exports = __webpack_public_path__ + "img/ru.2e27fbea.svg";